import React from 'react';
import PropTypes from 'prop-types';

import { cmsContentParser } from '../../shared/utils/cms/cms';

import './cms-html-content.scss';

function CmsHtmlContent(props) {
  const { className, html } = props;

  const content = html ? html.replace(/\\"/g, '"') : '';

  return (
    <div className={className || 'cms-html-content'}>
      {cmsContentParser(content)}
    </div>
  );
}

CmsHtmlContent.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string
};

export default CmsHtmlContent;
